/** Cliente da seção Changelog: o listão de data e o que mudou, mais recente primeiro. */
import { api } from '../../api/cliente';

const BASE = '/api/projetos/mistik-island/changelog';

/**
 * GG Pilot é esta ferramenta; Mistik Island é o jogo em si, que roda no `/admin` de
 * outro sistema — sem contrato com este. As duas listas não se misturam.
 */
export type Sistema = 'GG_PILOT' | 'MISTIK_ISLAND';

export interface EntradaDeChangelog {
  id: number;
  sistema: Sistema;
  /** ISO (aaaa-mm-dd). É por ela que a lista é ordenada. */
  data: string;
  /** Rótulo curto por assunto (ex.: "Cenas", "Admin", "Pipeline"). Opcional. */
  tema?: string;
  texto: string;
  criadoPor?: string;
  criadoEm?: string;
}

export interface ListaDeChangelog {
  entradas: EntradaDeChangelog[];
  total: number;
}

export const CHAVE_CHANGELOG = (sistema?: Sistema) => ['changelog', sistema ?? 'todos'] as const;

export function listar(sistema?: Sistema): Promise<ListaDeChangelog> {
  return api<ListaDeChangelog>(sistema ? `${BASE}?sistema=${sistema}` : BASE);
}

export function lancar(dados: {
  sistema: Sistema;
  data: string;
  tema?: string;
  texto: string;
}): Promise<EntradaDeChangelog> {
  return api<EntradaDeChangelog>(BASE, { method: 'POST', body: JSON.stringify(dados) });
}

export function salvar(
  id: number,
  mudancas: { sistema?: Sistema; data?: string; tema?: string; texto?: string }
): Promise<EntradaDeChangelog> {
  return api<EntradaDeChangelog>(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(mudancas) });
}

export function excluir(id: number): Promise<void> {
  return api<void>(`${BASE}/${id}`, { method: 'DELETE' });
}

/** Os temas já usados no sistema, para sugerir em vez de digitar de novo. */
export function temas(sistema: Sistema): Promise<string[]> {
  return api<string[]>(`${BASE}/temas?sistema=${sistema}`);
}

/** "12 de março de 2026" — a data por extenso, porque a lista é uma linha do tempo. */
export function dataPorExtenso(iso: string): string {
  // Sem `new Date(iso)` cru: um "2026-03-12" é lido como UTC e vira 11/03 em fuso
  // negativo. O Brasil inteiro está em fuso negativo.
  const [ano, mes, dia] = iso.split('-').map(Number);
  return new Date(ano, mes - 1, dia).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
